import AmplifyRouter from '../services/amplify-router';

export default function (ctx, inject) {
  inject('navigator', new AmplifyRouter(ctx));
}
